module.exports = __webpack_public_path__ + "assets/ic_tree10.e2582b11.svg";